import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from '../../../../styles/Admin/commons/pageRow';

const _PageRow = ({ classes, children }) => (
  <div className={classes.pageButtonsWrap}>{children}</div>
);

export const PageRow = withStyles(styles)(_PageRow);
